<template>
    <div
        v-if="!isShopbuilder"
        class="type-country"
        :class="{'type-country--loader': loader || !countryLoaded}">
        <div class="type-country__step">
            <div class="type-country__title">
                {{ $translate("OD3dprimaV2::Template.typeCountryStep1") }}
            </div>
            <div class="type-country__type">
                <div
                    class="btn btn-primary"
                    :class="{'btn-primary--disabled': type === 'b2c'}"
                    @click="setType('b2b')">
                    {{ $translate("OD3dprimaV2::Template.typeCountryB2B") }}
                </div>
                <div
                    class="btn btn-primary"
                    :class="{'btn-primary--disabled': type === 'b2b'}"
                    @click="setType('b2c')">
                    {{ $translate("OD3dprimaV2::Template.typeCountryB2C") }}
                </div>
            </div>
        </div>
        <div
            class="type-country__step"
            :class="{'type-country__step--loading': !countryLoaded}">
            <transition name="fade" mode="out-in">
                <div
                    v-if="isCheckout && !step2"
                    key="checkout_content"
                    class="type-country__confirm">
                    <div
                        class="type-country__title"
                        v-html="countryFlagNameDelivery"></div>
                    <div
                        class="btn btn-primary"
                        v-if="this.country.isoCode2"
                        @click="$parent.$emit('country-set', {type: type})">
                        {{
                            $translate("OD3dprimaV2::Template.typeCountryNext")
                        }}
                    </div>
                    <button class="btn btn-primary" @click="step2 = true">
                        {{ $translate("OD3dprimaV2::Template.typeCountryNo") }}
                    </button>
                </div>
                <div v-else key="modal_content">
                    <div
                        class="type-country__title"
                        v-html="countryFlagName"></div>
                    <div
                        class="btn btn-primary mb-0"
                        v-if="this.country.isoCode2"
                        @click="update(country)">
                        {{
                            $translate("OD3dprimaV2::Template.typeCountryNext")
                        }}
                    </div>
                    <div
                        class="type-country__select-box"
                        v-if="shippingCountries.length > 1">
                        <div class="type-country__select-box-upper">
                            <div
                                class="
                                    type-country__title
                                    type-country__title--bold
                                ">
                                <template v-if="this.country.isoCode2">
                                    {{
                                        $translate(
                                            "OD3dprimaV2::Template.typeCountrySelect"
                                        )
                                    }}
                                </template>
                                <template v-else>
                                    {{
                                        $translate(
                                            "OD3dprimaV2::Template.typeCountrySelectNA"
                                        )
                                    }}
                                </template>
                            </div>
                            <div class="position-relative w-100">
                                <i
                                    v-if="shippingCountryModel"
                                    class="flag-icon flag-icon--absolute"
                                    :class="
                                        'flag-icon-' +
                                        (shippingCountryModel &&
                                        shippingCountryModel.isoCode2
                                            ? shippingCountryModel.isoCode2.toLowerCase()
                                            : '')
                                    "></i>
                                <select
                                    v-if="shippingCountries.length > 1"
                                    class="form-control type-country__select"
                                    :class="
                                        shippingCountryModel
                                            ? 'type-country__select--flag'
                                            : ''
                                    "
                                    v-model="shippingCountryModel">
                                    <option value="null" disabled selected>
                                        {{
                                            $translate(
                                                "OD3dprimaV2::Template.typeCountryPleaseSelect"
                                            )
                                        }}
                                    </option>
                                    <option
                                        v-for="shippingCountry in shippingCountries"
                                        :value="shippingCountry"
                                        :key="shippingCountry.id"
                                        v-if="shippingCountry.currLangName">
                                        {{ shippingCountry.currLangName }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <button
                            class="btn btn-primary"
                            :disabled="shippingCountryModel === null"
                            @click="update">
                            {{
                                $translate(
                                    "OD3dprimaV2::Template.typeCountryAccept"
                                )
                            }}
                        </button>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import {mapState, mapGetters} from "vuex";
    import {isNullOrUndefined} from "ceres/app/helper/utils";
    import {
        getCookie,
        setCookie,
        setPriceTypeMapCookie,
    } from "~/app/helper/Cookie";
    import {getContinentCode, getCurrencyByCountry} from "~/app/helper/Country";
    import {jQueryGet} from "../../helper/jQueryGet";

    const ApiService = require("ceres/app/services/ApiService");

    export default {
        props: {
            langUrls: null,
            langList: null,
            reload: {
                type: Boolean,
                default: true,
            },
            isCheckout: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                cookie: null,
                countryLoaded: false,
                country: {
                    currLangName: " ",
                },
                type: "",
                loader: false,
                shippingCountryModel: null,
                lang: App.language,
                currency: App.currencyCode,
                defaultLang: App.defaultLanguage,
                continentCode: "",
                langGermanCodes: ["DE", "CH", "AT"],
                step2: false,
                newCurrency: "",
                isShopbuilder: App.isShopBuilder,
                specialCountryIds: [
                    255, 256, 261, 262, 263, 264, 266, 267, 268, 269, 270,
                ],
            };
        },
        computed: {
            ...mapState({
                localization: (state) => state.localization,
                basketItems: (state) => state.basket.items,
                currentPriceType: (state) =>
                    state.localization.currentPriceType,
            }),
            ...mapGetters(["getCountryName", "isLoggedIn"]),
            /**
             * If a item in basket has free4 = '1' the following shipping country's are hidden, because the item
             * can not be delivered in the following country's:
             *      - 1   => Germany
             *      - 2   => Austria
             *      - 4   => Switzerland
             *      - 255 => Helgoland Germany
             */
            shippingCountries() {
                if (this.basketItems.length > 0) {
                    let shippingCountries = [];

                    if (
                        typeof this.basketItems.find(
                            (item) => item.variation.data.item.free4 === "1"
                        ) !== "undefined"
                    ) {
                        for (
                            let i = 0;
                            i < this.localization.shippingCountries.length;
                            i++
                        ) {
                            if (
                                ![1, 2, 4, 255].includes(
                                    this.localization.shippingCountries[i].id
                                )
                            ) {
                                shippingCountries.push(
                                    this.localization.shippingCountries[i]
                                );
                            }
                        }

                        return shippingCountries;
                    }
                }

                return this.localization.shippingCountries;
            },
            countryFlagName() {
                return this.getFlagString(
                    this.country,
                    "OD3dprimaV2::Template.typeCountryStep21"
                );
            },
            countryFlagNameDelivery() {
                const shippingCountry = this.shippingCountries.find(
                    (country) =>
                        country.id === this.localization.shippingCountryId
                );

                return this.getFlagString(
                    shippingCountry,
                    "OD3dprimaV2::Template.typeCountryStep31"
                );
            },
            shopUrl() {
                return window.location.origin + "/";
            },
        },
        mounted() {
            if (
                !this.isShopbuilder &&
                (isNullOrUndefined(getCookie("customer_type_country")) ||
                    this.isCheckout)
            ) {
                this.cookie = getCookie("price_type_map");
                this.type = this.currentPriceType;

                this.geoDetection();
            }
        },
        methods: {
            setType(type) {
                this.type = type;
                setPriceTypeMapCookie(this.lang, type);
            },
            geoDetection() {
                ApiService.get("/rest/OD3dprimaV2/geo/detection")
                    .done((response) => {
                        this.country = this.translateCountryCode(response);

                        if (!isNullOrUndefined(response["continentCode"])) {
                            this.continentCode = response["continentCode"];
                        }
                        this.handleModalAfterDetection();
                    })
                    .fail((response) => {
                        console.error(response);
                        this.country = this.translateCountryCode(this.lang);
                        this.handleModalAfterDetection();
                    })
                    .always(() => (this.countryLoaded = true));
            },
            handleModalAfterDetection() {
                if (window.location.href.indexOf("nomodal") === -1) {
                    document.body.classList.add(
                        "detect-customer-type-country--active"
                    );

                    if (
                        isNullOrUndefined(getCookie("customer_type_country")) &&
                        !this.isLoggedIn
                    ) {
                        $("#detect-customer-type-country-modal").modal("show");
                    }
                } else {
                    this.update(this.country);
                }
            },
            translateCountryCode(code) {
                let country = null;

                if (!isNullOrUndefined(code["countryCode"])) {
                    /**
                     * specialCountryIds are special city/communities in the country like Helgoland or Livigno
                     * GEO API only detects the country so we can ignore these because its mapped to country
                     */
                    country = this.shippingCountries.find(
                        (country) =>
                            country.isoCode2 ===
                                code["countryCode"].toUpperCase() &&
                            !this.specialCountryIds.includes(country.id)
                    );
                }

                if (!isNullOrUndefined(country)) {
                    return country;
                }

                return {
                    currLangName: !isNullOrUndefined(code["country"])
                        ? code["country"]
                        : code,
                };
            },
            update(country) {
                this.loader = true;

                let continentCode = this.continentCode;

                //country is set on "yes, go on" button click otherwise its a change in shipping country select
                if (!isNullOrUndefined(country.screenX)) {
                    country = this.shippingCountryModel;
                    continentCode = getContinentCode(country);
                }

                const newLang = this.getNewLang(country);
                const newCurrency = getCurrencyByCountry(
                    country,
                    continentCode
                );
                console.log(newCurrency);
                console.log("newLang");
                console.log(newLang);
                if (this.currency !== newCurrency) {
                    this.newCurrency = newCurrency;
                }

                if (
                    this.localization.shippingCountryId !== country.id ||
                    this.lang !== newLang.code ||
                    this.newCurrency !== "" ||
                    this.currentPriceType !== this.type
                ) {
                    let url = window.location.origin + window.location.pathname;
                    let params = window.location.search;

                    if (this.lang !== newLang.code || url !== newLang.url) {
                        url = newLang.url;
                    }
                    if (this.newCurrency !== "") {
                        if (params !== "") {
                            let tmp = new URL(window.location.href);
                            tmp.searchParams.set("currency", this.newCurrency);
                            params = tmp.search;
                        } else {
                            params = "?" + "currency=" + this.newCurrency;
                        }

                        if (
                            newLang.code === "en" &&
                            this.newCurrency !== "EUR"
                        ) {
                            let tmp = new URL(url + params);
                            url = tmp.origin + "/en" + tmp.pathname;
                        }
                    }

                    this.setUrlAndCookie(
                        url + params,
                        newLang.code,
                        country.id
                    );
                    return;
                }

                setCookie("customer_type_country", true);
                setPriceTypeMapCookie(this.lang, this.type);

                this.hide();
                this.$parent.$emit("country-set", {type: this.type});

                if (newLang.code === "en" && this.newCurrency !== "EUR") {
                    let tmp = new URL(url + params);
                    url = tmp.origin + "/en" + tmp.pathname;
                }
            },
            getNewLang(country) {
                let langUrls = this.langUrls;

                if (langUrls.length === 0) {
                    langUrls = this.getFallbackLangUrls();
                }

                if (
                    this.langGermanCodes.includes(country.isoCode2) &&
                    !isNullOrUndefined(langUrls["de"])
                ) {
                    return {
                        code: "de",
                        url: langUrls["de"],
                    };
                }
                if (
                    country.isoCode2 === "SE" &&
                    !isNullOrUndefined(langUrls["sv"])
                ) {
                    return {
                        code: "se",
                        url: langUrls["sv"],
                    };
                }
                if (
                    country.isoCode2 === "DK" &&
                    !isNullOrUndefined(langUrls["da"])
                ) {
                    return {
                        code: "da",
                        url: langUrls["da"],
                    };
                }
                if (
                    country.isoCode2 === "NL" &&
                    !isNullOrUndefined(langUrls["nl"])
                ) {
                    return {
                        code: "nl",
                        url: langUrls["nl"],
                    };
                }
                if (
                    country.isoCode2 === "PL" &&
                    !isNullOrUndefined(langUrls["pl"])
                ) {
                    return {
                        code: "pl",
                        url: langUrls["pl"],
                    };
                }
                if (
                    country.isoCode2 === "FI" &&
                    !isNullOrUndefined(langUrls["tr"])
                ) {
                    return {
                        code: "tr",
                        url: langUrls["tr"],
                    };
                }
                if (!isNullOrUndefined(langUrls["en"])) {
                    return {
                        code: "en",
                        url: langUrls["en"],
                    };
                }

                return {
                    code: "x-default",
                    url: !isNullOrUndefined(langUrls["x-default"])
                        ? langUrls["x-default"]
                        : this.shopUrl,
                };
            },
            getFallbackLangUrls() {
                let list = [];

                for (let i = 0; i < this.langList.length; i++) {
                    list[this.langList[i] === "se" ? "sv" : this.langList[i]] =
                        this.shopUrl +
                        (this.langList[i] !== this.defaultLang
                            ? this.langList[i]
                            : "");
                }

                list["x-default"] = {
                    code: this.defaultLang,
                    url: this.shopUrl,
                };

                return list;
            },
            getFlagString(country, translationKey) {
                let name = "";

                if (
                    !isNullOrUndefined(country) &&
                    !isNullOrUndefined(country.isoCode2)
                ) {
                    name =
                        '<i class="flag-icon flag-icon-' +
                        country.isoCode2.toLowerCase() +
                        '"></i> ' +
                        country.currLangName;
                }

                return this.$translate(translationKey, {country: name});
            },
            setUrlAndCookie(url, lang, countryId) {
                setPriceTypeMapCookie(lang, this.type);
                setCookie("customer_type_country", true);

                if (
                    (this.lang !== lang ||
                        this.newCurrency !== App.currencyCode) &&
                    !this.isCheckout
                ) {
                    /**
                     * Use custom jQuery get request, because plenty ApiService crashes if lang URL is 404. At this point this
                     * is necessary if customer entry point is not the homepage.
                     */
                    jQueryGet(url).always(() => {
                        this.changeShippingCountry(countryId).then(() => {
                            this.updateUrl(url);
                        });
                    });
                } else {
                    this.changeShippingCountry(countryId).then(() => {
                        this.updateUrl(url);
                    });
                }
            },
            changeShippingCountry(countryId) {
                return new Promise((resolve) => {
                    if (this.localization.shippingCountryId !== countryId) {
                        if (!this.reload) {
                            this.$store.commit(
                                "setShippingCountryReload",
                                false
                            );
                        }

                        ApiService.post("/rest/io/shipping/country", {
                            shippingCountryId: countryId,
                        }).always(() => {
                            resolve();
                        });
                    } else {
                        resolve();
                    }
                });
            },
            updateUrl(url) {
                if (this.reload) {
                    url = new URL(url);

                    /**
                     * Check if page has trailing slash and add or remove in url if necessary.
                     */
                    if (url.pathname.slice(-1) !== "/" && App.trailingSlash) {
                        url.pathname += "/";
                    }
                    if (url.pathname.slice(-1) === "/" && !App.trailingSlash) {
                        url.pathname = url.pathname.slice(0, -1);
                    }

                    url.searchParams.delete("currency");

                    window.location = url.href;
                } else if (
                    this.currency !== this.newCurrency &&
                    this.newCurrency !== "" &&
                    window.location.search.indexOf("backlink=") > -1
                ) {
                    let href = new URL(window.location.href);
                    let backlink = new URL(href.searchParams.get("backlink"));

                    backlink.searchParams.set("currency", this.newCurrency);

                    /**
                     * Here the trailing slash and currency parameter are required, otherwise the currency switch
                     * won't work and the Klarna checkout is broken.
                     */
                    if (backlink.pathname.slice(-1) !== "/") {
                        backlink.pathname += "/";
                    }

                    href.searchParams.set("backlink", backlink.href);

                    /**
                     * Check if page has trailing slash and add in url if necessary.
                     */
                    if (href.pathname.slice(-1) !== "/" && App.trailingSlash) {
                        href.pathname += "/";
                    }

                    const titleElement =
                        document.getElementsByTagName("title")[0];
                    window.history.replaceState(
                        {requireReload: false},
                        titleElement ? titleElement.innerHTML : "",
                        href.href
                    );
                }

                this.$parent.$emit("country-set", {type: this.type});
            },
            hide() {
                $("#detect-customer-type-country-modal").modal("hide");
                document.body.classList.remove(
                    "detect-customer-type-country--active"
                );
            },
        },
    };
</script>
